import { useState, useEffect } from "react";
import { saveAssetServiceDetails } from "../../Api/AssetManagement";
import { Container, Form, Button, Row, Col, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../../Components/Logo";
import { useAssetContext } from "../../Context/MasterContext/AssetContext";
import { useMasterDataContext } from "../../Context/masterDataContext";
import { Accordion, AccordionItem, AccordionBody } from "react-bootstrap";

import "../../Styling/Title.css";
import "../../Styling/Accordion.css";
import "../../Styling/SaveButton.css";
import "../../Styling/ResetButton.css";

const AddAssetService = () => {
  const navigate = useNavigate();

  const {
    assetCatTypes,
    loadCatTypes,
    fetchAssetData,
    loadAssetMaster,
    loadDeprecMethod,
  } = useAssetContext();

  const { merchantsData, loadMerchants } = useMasterDataContext();

  const [loading, setLoading] = useState(false);

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;

  const intitalValues = {
    asset_ID: "",
    service_Date: "",
    service_Type: "",
    service_Provider: "",
    contact_Details: "",
    service_Cost: "",
    under_AMC: "",
    next_Service_Due_Date: "",
    remarks: "",
  };

  const [formValues, setFormValues] = useState(intitalValues);

  const handleChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await saveAssetServiceDetails(formValues, userId);
      toast.success(`🦄 Added Successfully`);
      setFormValues(intitalValues);
    } catch (error) {
      toast.error(`🦄 Error : ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCatTypes();
    loadDeprecMethod();
    loadAssetMaster();
    loadMerchants();
  }, []);

  return (
    <div className="container asset-master-fields">
      <h2 className="fields-title">Add Asset Service</h2>

      {loading && (
        <span className="d-inline-flex align-items-center gap-2">
          <Spinner animation="border" size="sm" /> Processing...
        </span>
      )}

      <Form onSubmit={handleSubmit} className="fields-form">

        <Accordion defaultActiveKey="0" className="asset-master-accordion">
          <AccordionItem eventKey="0">
            <AccordionBody>

              <Row className="g-3">

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>
                      Select Asset <span className="text-red">**</span>
                    </Form.Label>

                    <Form.Select
                      name="asset_ID"
                      value={formValues.asset_ID}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Asset</option>
                      {fetchAssetData.map((option) => (
                        <option key={option.asset_ID} value={option.asset_ID}>
                          {option.asset_ID}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>
                      Service Date <span className="text-red">**</span>
                    </Form.Label>

                    <Form.Control
                      type="date"
                      name="service_Date"
                      value={formValues.service_Date}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>
                      Service Type <span className="text-red">**</span>
                    </Form.Label>

                    <Form.Select
                      name="service_Type"
                      value={formValues.service_Type}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Service Type</option>

                      {assetCatTypes.map((option) => (
                        <option
                          key={option.assetCategoryId}
                          value={option.assetCategoryId}
                        >
                          {option.assetCategoryDesc}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>
                      Service Provider <span className="text-red">**</span>
                    </Form.Label>

                    <Form.Select
                      name="service_Provider"
                      value={formValues.service_Provider}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Ser. Provider</option>

                      {merchantsData.map((option) => (
                        <option
                          key={option.merchantCode}
                          value={option.merchantCode}
                        >
                          {option.merchantCode} - {option.merchantName}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>
                      Contact Details <span className="text-red">**</span>
                    </Form.Label>

                    <Form.Control
                      type="text"
                      name="contact_Details"
                      value={formValues.contact_Details}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>
                      Service Cost <span className="text-red">**</span>
                    </Form.Label>

                    <Form.Control
                      type="text"
                      name="service_Cost"
                      value={formValues.service_Cost}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>AMC</Form.Label>

                    <Form.Select
                      name="under_AMC"
                      value={formValues.under_AMC}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select AMC</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>Next Service Date</Form.Label>

                    <Form.Control
                      type="date"
                      name="next_Service_Due_Date"
                      value={formValues.next_Service_Due_Date}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>Remarks</Form.Label>

                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="Remarks"
                      value={formValues.Remarks}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

              </Row>

            </AccordionBody>
          </AccordionItem>
        </Accordion>

        <div className="fields-btn-container" style={{ marginTop: 16 }}>
          <Button
            variant="primary"
            type="submit"
            className="fields-submit"
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Service"}
          </Button>
        </div>

      </Form>
    </div>
  );
};

export default AddAssetService;